import { CallStats, StatsCommon } from '#common/stats';
export class SnapshotManagerStats extends StatsCommon {
    create;
    list;
    delete;
    constructor(log) {
        super();
        this.create = new CallStats('create', log);
        this.list = new CallStats('list', log);
        this.delete = new CallStats('delete', log);
    }
}
